/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '../../buttons/icon-button/icon-button.component.ngfactory';
import * as import2 from '../../buttons/icon-button/icon-button.component';
import * as import3 from '@angular/common';
import * as import4 from 'ng2-translate/src/translate.pipe';
import * as import5 from 'ng2-translate/src/translate.service';
import * as import6 from '../../buttons/link/link.component.ngfactory';
import * as import7 from '../../buttons/link/link.component';
import * as import8 from '../../notification/footer-messages/footer-messages.component.ngfactory';
import * as import9 from '../../notification/footer-messages/footer-messages.component';
import * as import10 from '../../notification/notification.service';
import * as import11 from '../../html-utils/html.pipe';
import * as import12 from '@angular/platform-browser';
import * as import13 from './modal-page-layout.component';
import * as import14 from '../../orchestration/page';
import * as import15 from '../../orchestration/navigation.service';
const styles_ModalPageLayoutComponent:any[] = ([] as any[]);
export const RenderType_ModalPageLayoutComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_ModalPageLayoutComponent,
  data: {}
}
);
function View_ModalPageLayoutComponent_2(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-icon-button',[[
        'class',
        'page-header-main-button refresh'
      ]
    ],[
      [
        1,
        'type',
        0
      ]
      ,
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'unavailable',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'onActivate'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onActivate' === en)) {
        const pd_0:any = ((<any>co.onRefresh.emit()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import1.View_IconButtonComponent_0,import1.RenderType_IconButtonComponent)),
      import0.ɵdid(49152,(null as any),0,import2.IconButtonComponent,([] as any[]),{type: [
        0,
        'type'
      ]
    },{onActivate: 'onActivate'})
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_3:any = co.IconButtonType.REFRESH;
    ck(v,1,0,currVal_3);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).type;
    const currVal_1:any = import0.ɵnov(v,1).disabled;
    const currVal_2:any = import0.ɵnov(v,1).unavailable;
    ck(v,0,0,currVal_0,currVal_1,currVal_2);
  });
}
function View_ModalPageLayoutComponent_3(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-icon-button',[[
        'class',
        'page-header-main-button close'
      ]
    ],[
      [
        1,
        'type',
        0
      ]
      ,
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'unavailable',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'onActivate'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onActivate' === en)) {
        const pd_0:any = ((<any>co.close()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import1.View_IconButtonComponent_0,import1.RenderType_IconButtonComponent)),
      import0.ɵdid(49152,(null as any),0,import2.IconButtonComponent,([] as any[]),{type: [
        0,
        'type'
      ]
    },{onActivate: 'onActivate'})
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_3:any = co.IconButtonType.CLOSE;
    ck(v,1,0,currVal_3);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).type;
    const currVal_1:any = import0.ɵnov(v,1).disabled;
    const currVal_2:any = import0.ɵnov(v,1).unavailable;
    ck(v,0,0,currVal_0,currVal_1,currVal_2);
  });
}
function View_ModalPageLayoutComponent_5(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'page-header-main-heading-titles-title'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import3.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    import0.ɵpod(['with-subtitle']),
    (l()(),import0.ɵted((null as any),[
      '\n                        ',
      '\n                    '
    ]
    )),
    import0.ɵpid(131072,import4.TranslatePipe,[
      import5.TranslateService,
      import0.ChangeDetectorRef
    ]
    )
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = 'page-header-main-heading-titles-title';
    const currVal_1:any = ck(v,2,0,co.subtitle);
    ck(v,1,0,currVal_0,currVal_1);
  },(ck,v) => {
    var co:any = v.component;
    const currVal_2:any = import0.ɵunv(v,3,0,import0.ɵnov(v,4).transform(co.title,co.translationParams));
    ck(v,3,0,currVal_2);
  });
}
function View_ModalPageLayoutComponent_6(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'page-header-main-heading-titles-subtitle'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                        ',
      '\n                    '
    ]
    )),
    import0.ɵpid(131072,import4.TranslatePipe,[
      import5.TranslateService,
      import0.ChangeDetectorRef
    ]
    )
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵunv(v,1,0,import0.ɵnov(v,2).transform(co.subtitle,co.translationParams));
    ck(v,1,0,currVal_0);
  });
}
function View_ModalPageLayoutComponent_4(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),12,'div',[[
        'class',
        'page-header-main-heading'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import3.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    import0.ɵpod([
      'button-left',
      'button-right'
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),7,'div',[[
        'class',
        'page-header-main-heading-titles'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ModalPageLayoutComponent_5)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ModalPageLayoutComponent_6)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n            ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = 'page-header-main-heading';
    const currVal_1:any = ck(v,2,0,(co.showLeftRefreshButton || co.showLeftCloseButton),(co.showRightRefreshButton || co.showRightCloseButton));
    ck(v,1,0,currVal_0,currVal_1);
    const currVal_2:any = co.title;
    ck(v,7,0,currVal_2);
    const currVal_3:any = (co.showSubtitle && co.subtitle);
    ck(v,10,0,currVal_3);
  },(null as any));
}
function View_ModalPageLayoutComponent_7(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-link',([] as any[]),(null as any),[[
        (null as any),
        'onActivate'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onActivate' === en)) {
        const pd_0:any = ((<any>co.close()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import6.View_LinkComponent_0,import6.RenderType_LinkComponent)),
    import0.ɵdid(49152,(null as any),0,import7.LinkComponent,([] as any[]),{
      link: [
        0,
        'link'
      ]
      ,
      underlined: [
        1,
        'underlined'
      ]
      ,
      plain: [
        2,
        'plain'
      ]

    }
    ,{onActivate: 'onActivate'})
  ]
  ,(ck,v) => {
    const currVal_0:any = 'woa.button.common.cancel';
    const currVal_1:any = false;
    const currVal_2:any = true;
    ck(v,1,0,currVal_0,currVal_1,currVal_2);
  },(null as any));
}
function View_ModalPageLayoutComponent_8(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-icon-button',[[
        'class',
        'page-header-main-button refresh'
      ]
    ],[
      [
        1,
        'type',
        0
      ]
      ,
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'unavailable',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'onActivate'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onActivate' === en)) {
        const pd_0:any = ((<any>co.onRefresh.emit()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import1.View_IconButtonComponent_0,import1.RenderType_IconButtonComponent)),
      import0.ɵdid(49152,(null as any),0,import2.IconButtonComponent,([] as any[]),{type: [
        0,
        'type'
      ]
    },{onActivate: 'onActivate'})
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_3:any = co.IconButtonType.REFRESH;
    ck(v,1,0,currVal_3);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).type;
    const currVal_1:any = import0.ɵnov(v,1).disabled;
    const currVal_2:any = import0.ɵnov(v,1).unavailable;
    ck(v,0,0,currVal_0,currVal_1,currVal_2);
  });
}
function View_ModalPageLayoutComponent_9(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-icon-button',[[
        'class',
        'page-header-main-button close'
      ]
    ],[
      [
        1,
        'type',
        0
      ]
      ,
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'unavailable',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'onActivate'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onActivate' === en)) {
        const pd_0:any = ((<any>co.close()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import1.View_IconButtonComponent_0,import1.RenderType_IconButtonComponent)),
      import0.ɵdid(49152,(null as any),0,import2.IconButtonComponent,([] as any[]),{type: [
        0,
        'type'
      ]
    },{onActivate: 'onActivate'})
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_3:any = co.IconButtonType.CLOSE;
    ck(v,1,0,currVal_3);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).type;
    const currVal_1:any = import0.ɵnov(v,1).disabled;
    const currVal_2:any = import0.ɵnov(v,1).unavailable;
    ck(v,0,0,currVal_0,currVal_1,currVal_2);
  });
}
function View_ModalPageLayoutComponent_1(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),30,'div',[[
        'class',
        'page-header'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import3.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    import0.ɵpod([
      'with-content',
      'page-alignment-top'
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),23,'div',[[
        'class',
        'page-header-main'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ModalPageLayoutComponent_2)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ModalPageLayoutComponent_3)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    import0.ɵncd((null as any),0),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ModalPageLayoutComponent_4)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    import0.ɵncd((null as any),1),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ModalPageLayoutComponent_7)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ModalPageLayoutComponent_8)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ModalPageLayoutComponent_9)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    import0.ɵncd((null as any),2),
    (l()(),import0.ɵted((null as any),['\n    ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = 'page-header';
    const currVal_1:any = ck(v,2,0,co.showContent,(co.page.containerComponentRef.instance.pageSpec.geometry.alignment === co.PageAlignment.TOP));
    ck(v,1,0,currVal_0,currVal_1);
    const currVal_2:any = co.showLeftRefreshButton;
    ck(v,7,0,currVal_2);
    const currVal_3:any = co.showLeftCloseButton;
    ck(v,10,0,currVal_3);
    const currVal_4:any = (co.title || co.subtitle);
    ck(v,15,0,currVal_4);
    const currVal_5:any = co.showCancelLink;
    ck(v,20,0,currVal_5);
    const currVal_6:any = co.showRightRefreshButton;
    ck(v,23,0,currVal_6);
    const currVal_7:any = co.showRightCloseButton;
    ck(v,26,0,currVal_7);
  },(null as any));
}
function View_ModalPageLayoutComponent_11(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),3,'div',[[
        'class',
        'page-content-messages'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    import0.ɵncd((null as any),3),
    (l()(),import0.ɵted((null as any),['\n        ']))
  ]
  ,(null as any),(null as any));
}
function View_ModalPageLayoutComponent_12(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'page-content-body-text'
      ]
      ],[[
        8,
        'innerHTML',
        1
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    import0.ɵpid(131072,import4.TranslatePipe,[
      import5.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    import0.ɵppd(1)
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵunv(v,0,0,ck(v,2,0,import0.ɵnov((<any>(<any>v.parent).parent),0),import0.ɵunv(v,0,0,import0.ɵnov(v,1).transform(co.contentText,co.translationParams))));
    ck(v,0,0,currVal_0);
  });
}
function View_ModalPageLayoutComponent_10(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,[
      [
        1,
        0
      ]
      ,
      [
        'scroller',
        1
      ]

    ]
      ,(null as any),12,'div',[[
        'class',
        'page-content'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ModalPageLayoutComponent_11)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),6,'div',[[
        'class',
        'page-content-body'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ModalPageLayoutComponent_12)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    import0.ɵncd((null as any),4),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n    ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = ((co.contentMessages == null)? (null as any): co.contentMessages.length);
    ck(v,3,0,currVal_0);
    const currVal_1:any = co.contentText;
    ck(v,8,0,currVal_1);
  },(null as any));
}
function View_ModalPageLayoutComponent_14(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),3,'div',([] as any[]),[[
        8,
        'className',
        0
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
    import0.ɵncd((null as any),7),
    (l()(),import0.ɵted((null as any),['\n            ']))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵinlineInterpolate(1,'page-footer-main-controls ',co.footerControlOrientation,'');
    ck(v,0,0,currVal_0);
  });
}
function View_ModalPageLayoutComponent_13(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),19,'div',[[
        'class',
        'page-footer'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import3.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    import0.ɵpod(['with-footer-border']),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,'woa-footer-messages',([] as any[]),(null as any),(null as any),(null as any),import8.View_FooterMessagesComponent_0,import8.RenderType_FooterMessagesComponent)),
    import0.ɵdid(49152,(null as any),0,import9.FooterMessagesComponent,[
      import10.NotificationService,
      import0.ChangeDetectorRef
    ]
    ,(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    import0.ɵncd(1,5),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),8,'div',[[
        'class',
        'page-footer-main'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    import0.ɵncd((null as any),6),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ModalPageLayoutComponent_14)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    import0.ɵncd((null as any),8),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n    ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = 'page-footer';
    const currVal_1:any = ck(v,2,0,(co.showFooterBorder || ((co.showFooterBorder === (undefined as any)) && co.footerControls.length)));
    ck(v,1,0,currVal_0,currVal_1);
    const currVal_2:any = co.footerControls.length;
    ck(v,15,0,currVal_2);
  },(null as any));
}
export function View_ModalPageLayoutComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    import0.ɵpid(0,import11.HtmlPipe,[import12.DomSanitizer]),
    import0.ɵqud(671088640,1,{scrollerElementRef: 0}),
      (l()(),import0.ɵeld(0,(null as any),(null as any),11,'div',[[
        'class',
        'modal-page'
      ]
      ],[[
        2,
        'allowSafeArea',
        (null as any)
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import3.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ModalPageLayoutComponent_1)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ModalPageLayoutComponent_10)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ModalPageLayoutComponent_13)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n'])),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import13.ModalPageLayoutComponent = v.component;
    const currVal_1:any = 'modal-page';
    const currVal_2:any = co.backgroundColorPairClass;
    ck(v,3,0,currVal_1,currVal_2);
    const currVal_3:any = co.showHeader;
    ck(v,6,0,currVal_3);
    const currVal_4:any = co.showContent;
    ck(v,9,0,currVal_4);
    const currVal_5:any = co.showFooter;
    ck(v,12,0,currVal_5);
  },(ck,v) => {
    var co:import13.ModalPageLayoutComponent = v.component;
    const currVal_0:any = co.allowSafeArea;
    ck(v,2,0,currVal_0);
  });
}
function View_ModalPageLayoutComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,'woa-modal-page-layout',([] as any[]),(null as any),(null as any),(null as any),View_ModalPageLayoutComponent_0,RenderType_ModalPageLayoutComponent)),
    import0.ɵdid(114688,(null as any),2,import13.ModalPageLayoutComponent,[
      import14.Page,
      import15.NavigationService
    ]
    ,(null as any),(null as any)),
    import0.ɵqud(603979776,1,{contentMessages: 1}),
    import0.ɵqud(603979776,2,{footerControls: 1}),
    import0.ɵprd(6144,(null as any),import14.PageLayout,(null as any),[import13.ModalPageLayoutComponent])
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
export const ModalPageLayoutComponentNgFactory:import0.ComponentFactory<import13.ModalPageLayoutComponent> = import0.ɵccf('woa-modal-page-layout',import13.ModalPageLayoutComponent,View_ModalPageLayoutComponent_Host_0,{
  showHeader: 'showHeader',
  showCloseButton: 'showCloseButton',
  showCancelLink: 'showCancelLink',
  closeButtonAlignment: 'closeButtonAlignment',
  showRefreshButton: 'showRefreshButton',
  showSubtitle: 'showSubtitle',
  title: 'title',
  subtitle: 'subtitle',
  translationParams: 'translationParams',
  showBackground: 'showBackground',
  backgroundColorPair: 'backgroundColorPair',
  contentText: 'contentText',
  showContent: 'showContent',
  padWhenNoContent: 'padWhenNoContent',
  showFooter: 'showFooter',
  showFooterBorder: 'showFooterBorder',
  footerControlOrientation: 'footerControlOrientation',
  allowSafeArea: 'allowSafeArea',
  customGeometry: 'customGeometry'
}
,{onRefresh: 'onRefresh'},[
  '[slot=header-left]',
  '[slot=header-right]',
  '[slot=header]',
  'woa-content-message',
  '*',
  'woa-footer-message',
  '[slot=footer-start]',
  '[woa-page-footer-control]',
  '[slot=footer-end]'
]
);
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/app/page-layout/modal-page-layout/modal-page-layout.component.ngfactory.ts